// in src/styleReducer.js
export const stylesReceived = (styles) => {
    return ({
    	type: 'TESTING',
    	payload: {styles}
    }); //default colors
};

export const stylesReducer = (previousState={}, {type, payload}) => {
	if (type === 'TESTING') {
		return payload.styles
	}
	return previousState
};